export const validateRichTextContent = (value: string) => {
  if (!value || value.trim() === '') {
    return false;
  }

  const textContent = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');

  return textContent.trim().length > 0;
};
